import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { IWeeklySummary } from '../IWeeklySummary';

export const getWeeklySummary = createAction(
  '[TimeCard/API] Get Weekly Summary',
  props<{ EmployeeListID: string, DRListID?: string, EmpAuthID?: number, StartDate?: Date, EndDate?: Date }>()
);

/////////////////////////////////////////////////////

export const loadWeeklySummarys = createAction(
  '[WeeklySummary/API] Load WeeklySummarys',
  props<{ weeklySummarys: IWeeklySummary[] }>()
);

export const addWeeklySummary = createAction(
  '[WeeklySummary/API] Add WeeklySummary',
  props<{ weeklySummary: IWeeklySummary }>()
);

export const upsertWeeklySummary = createAction(
  '[WeeklySummary/API] Upsert WeeklySummary',
  props<{ weeklySummary: IWeeklySummary }>()
);

export const addWeeklySummarys = createAction(
  '[WeeklySummary/API] Add WeeklySummarys',
  props<{ weeklySummarys: IWeeklySummary[] }>()
);

export const upsertWeeklySummarys = createAction(
  '[WeeklySummary/API] Upsert WeeklySummarys',
  props<{ weeklySummarys: IWeeklySummary[] }>()
);

export const updateWeeklySummary = createAction(
  '[WeeklySummary/API] Update WeeklySummary',
  props<{ weeklySummary: Update<IWeeklySummary> }>()
);

export const updateWeeklySummarys = createAction(
  '[WeeklySummary/API] Update WeeklySummarys',
  props<{ weeklySummarys: Update<IWeeklySummary>[] }>()
);

export const deleteWeeklySummary = createAction(
  '[WeeklySummary/API] Delete WeeklySummary',
  props<{ id: string }>()
);

export const deleteWeeklySummarys = createAction(
  '[WeeklySummary/API] Delete WeeklySummarys',
  props<{ ids: string[] }>()
);

export const clearWeeklySummarys = createAction(
  '[WeeklySummary/API] Clear WeeklySummarys'
);
